import { CharStatus } from '../../lib/statuses'
import classnames from 'classnames'
import { REVEAL_TIME_MS } from '../../constants/settings'
import { getStoredIsHighContrastMode } from '../../lib/localStorage'

type Props = {
  value?: number
  status?: CharStatus
  isRevealing?: boolean
  isCompleted?: boolean
  isCurrentRow?: boolean
  isCurrentCell?: boolean
  inGame?: boolean
  position?: number
}

export const Cell = ({
  value,
  status,
  isRevealing,
  isCompleted,
  isCurrentRow,
  isCurrentCell,
  inGame,
  position = 0,
}: Props) => {
  const isFilled = value !== undefined && !isCompleted
  const shouldReveal = isRevealing && isCompleted
  const animationDelay = `${position * REVEAL_TIME_MS}ms`
  const isHighContrast = getStoredIsHighContrastMode()

  const classes = classnames(
    'w-16 h-16 border-solid border-2 flex items-center justify-center mx-0.5 text-4xl font-bold rounded-md text-white',
    {
      'bg-slate-900/25 border-slate-600/25': !status,
      'border-slate-700 border-4 bg-transparent':
        (isCurrentRow || isCurrentCell) && inGame,
      'absent shadowed bg-slate-700 text-white border-slate-700':
        status === 'absent',
      'correct shadowed bg-orange-500 text-white border-orange-500':
        status === 'correct' && isHighContrast,
      'present shadowed bg-cyan-500 text-white border-cyan-500':
        status === 'present' && isHighContrast,
      'correct shadowed bg-green-500 text-white border-green-500':
        status === 'correct' && !isHighContrast,
      'present shadowed bg-yellow-500 text-white border-yellow-500':
        status === 'present' && !isHighContrast,
      'cell-fill-animation': isFilled,
      'cell-reveal': shouldReveal,
      'cell-cursor-animation': isCurrentCell && inGame,
    }
  )

  return (
    <div className={classes} style={{ animationDelay }}>
      <div className="letter-container" style={{ animationDelay }}>
        {value}
        {isCurrentCell && inGame && '_'}
      </div>
    </div>
  )
}
